import { Skeleton } from '../../../../feedback/Skeleton';
import { Box } from '../../../../layout/Box';
import { ContentColumn, ControlColumn, DateColumn, Row } from '../../styles';
import { FeedManagementRowSkeletonProps } from './types';

export const FeedManagementRowSkeleton = (props: FeedManagementRowSkeletonProps) => (
    <Row {...props} minWidth="100%">
        <ControlColumn>
            <Skeleton variant="rect" width={24} height={24} borderRadius={1} />
        </ControlColumn>
        <ControlColumn>
            <Skeleton variant="rect" width={24} height={24} borderRadius={1} />
        </ControlColumn>
        <Skeleton variant="rect" width={64} height={64} borderRadius={1} />
        <ContentColumn>
            <Box width="100%">
                <Skeleton variant="text" width="100%" height={14} />
                <Skeleton variant="text" width="80%" height={14} />
            </Box>
            <Skeleton variant="text" width={100} height={14} />
        </ContentColumn>
        <ContentColumn justifyContent="center">
            <Skeleton variant="text" width="100%" height={14} />
        </ContentColumn>
        <DateColumn>
            <Skeleton variant="text" width="80%" height={14} />
        </DateColumn>
        <ControlColumn>
            <Skeleton variant="rect" width={24} height={24} borderRadius={1} />
        </ControlColumn>
    </Row>
);
